import Link from 'next/link';
import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box } from '@mui/material';

export interface IBreadCrumbBar {
  breadcrumb: string[];
  locale: any;
  t: any;
}

export interface IBreadCrumbBarCustom {
  breadcrumb: { href: string; name: string }[];
  locale: any;
  t: any;
}

const linkStyle = {
  textDecoration: 'none',
  color: '#9E9E9E',
  fontSize: '14px',
  lineHeight: 1.8,
};

export const BreadcrumbBar = ({ breadcrumb, locale, t }: IBreadCrumbBar) => {
  const _breadcrumb = breadcrumb.filter((b) => !!b && b !== 'null');

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        py: '10px',
      }}
    >
      {/* หน้าแรก */}
      <Box sx={{ display: 'inline-flex', alignItems: 'center', mr: 1 }}>
        <Link legacyBehavior href="/" locale={locale}>
          <a style={linkStyle}>{t('app-home')}</a>
        </Link>
        {_breadcrumb.length > 0 && <ChevronRightIcon sx={{ fontSize: 18, mx: 1, color: '#9E9E9E' }} />}
      </Box>

      {/* Breadcrumb list */}
      {_breadcrumb.map((item, index) => {
        const href = _breadcrumb.slice(0, index + 1).join('/');
        const isLast = index === _breadcrumb.length - 1;
        return (
          <Box key={index} sx={{ display: 'inline-flex', alignItems: 'center', mr: 1 }}>
            <Link legacyBehavior href={`/${href}`} locale={locale}>
              <a
                style={{
                  ...linkStyle,
                }}
              >
                {item}
              </a>
            </Link>
            {!isLast && <ChevronRightIcon sx={{ fontSize: 18, mx: 1, color: '#9E9E9E' }} />}
          </Box>
        );
      })}
    </Box>
  );
};

export const BreadcrumbBarCustom = ({ breadcrumb, locale, t }: IBreadCrumbBarCustom) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        py: '10px',
      }}
    >
      {/* หน้าแรก */}
      <Box sx={{ display: 'inline-flex', alignItems: 'center', mr: 1 }}>
        <Link legacyBehavior href="/" locale={locale}>
          <a style={linkStyle}>{t('app-home')}</a>
        </Link>
        {breadcrumb.length > 0 && <ChevronRightIcon sx={{ fontSize: 18, mx: 1, color: '#9E9E9E' }} />}
      </Box>

      {/* Breadcrumb list */}
      {breadcrumb.map((item, index) => {
        const isLast = index === breadcrumb.length - 1;
        return (
          <Box key={index} sx={{ display: 'inline-flex', alignItems: 'center', mr: 1 }}>
            <Link legacyBehavior href={`/${item.href}`} locale={locale}>
              <a
                style={{
                  ...linkStyle,
                }}
              >
                {item.name}
              </a>
            </Link>
            {!isLast && <ChevronRightIcon sx={{ fontSize: 18, mx: 1, color: '#9E9E9E' }} />}
          </Box>
        );
      })}
    </Box>
  );
};
